// src/components/feature/BlogSampleOfferSlot.tsx
//
// BLOG-LEAD-MAGNET-SAMPLES-001 — the single mount that puts the free-sample
// form under EVERY classified blog article.
//
// Rendered by SharedFooter (the one component every article page renders), so
// no article page has to remember it. It renders nothing unless the current
// route is an exact key in BLOG_SAMPLE_OFFERS — the explicit, reviewed
// classification — so the homepage, product pages, portals, /blog itself and
// the state hubs are untouched. Works under the prerender's StaticRouter.

import { useLocation } from "react-router-dom";
import BlogSampleOffer from "@/components/feature/BlogSampleOffer";
import { blogSampleOfferFor } from "@/data/blogSampleOfferRegistry";

export default function BlogSampleOfferSlot() {
  const { pathname } = useLocation();
  const match = blogSampleOfferFor(pathname);
  if (!match) return null;
  return (
    <div data-pt-sample-slot="" className="bg-white">
      <div className="max-w-3xl mx-auto px-5 sm:px-6 py-10 sm:py-12">
        <BlogSampleOffer offer={match.offer} sourcePath={match.route} placement="end" />
      </div>
    </div>
  );
}
